import type { ReactNode } from 'react';
import React from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { ProtectedPage } from '../components/atoms';
import {
  AddClothingItem,
  AddDepartment,
  AddMember,
  AddWashCycle,
  Clothes,
  ClothingItem,
  Dashboard,
  Department,
  Departments,
  Login,
  Member,
  Members,
  WashCycles,
} from '../components/pages';
import { ROLE } from '../enums';

type RouterProps = {
  children?: ReactNode;
};

export function Router({ children }: RouterProps): React.JSX.Element {
  return (
    <BrowserRouter>
      {children}
      <Routes>
        <Route
          path='dashboard'
          element={
            <ProtectedPage>
              <Dashboard />
            </ProtectedPage>
          }
        />
        <Route
          path='abteilung'
          element={
            <ProtectedPage roles={[ROLE.ADMIN]}>
              <Outlet />
            </ProtectedPage>
          }
        >
          <Route path='' element={<Departments />} />
          <Route path='add' element={<AddDepartment />} />
          <Route path=':firedepartmentId' element={<Department />} />
        </Route>
        <Route
          path='mitglieder'
          element={
            <ProtectedPage>
              <Outlet />
            </ProtectedPage>
          }
        >
          <Route path='' element={<Members />} />
          <Route
            path='add'
            element={
              <ProtectedPage roles={[ROLE.ADMIN, ROLE.FD_ADMIN]}>
                <AddMember />
              </ProtectedPage>
            }
          />
          <Route path=':firefighterId' element={<Member />} />
        </Route>
        <Route
          path='kleidung'
          element={
            <ProtectedPage>
              <Outlet />
            </ProtectedPage>
          }
        >
          <Route path='' element={<Clothes />} />
          <Route
            path='add'
            element={
              <ProtectedPage roles={[ROLE.ADMIN, ROLE.FD_ADMIN]}>
                <AddClothingItem />
              </ProtectedPage>
            }
          />
          <Route path=':clothItemId' element={<ClothingItem />} />
        </Route>
        <Route
          path='waschzyklus'
          element={
            <ProtectedPage>
              <Outlet />
            </ProtectedPage>
          }
        >
          <Route path='' element={<WashCycles />} />
          <Route path='add' element={<AddWashCycle />} />
        </Route>
        <Route path='login' element={<Login />} />
        <Route path='/' element={<Navigate to='/dashboard' />} />
        <Route path='*' element={<h1>Actual no Page</h1>} />
      </Routes>
    </BrowserRouter>
  );
}
